// @flow
import React from 'react';
import type { Node } from 'react';

import styles from './MissedTargetIcon.module.scss';

type Props = {
  className: ?string
};

let MissedTargetIcon = ({ className }: Props): Node => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    viewBox="0 0 238.882 142.249"
    aria-labelledby="description"
  >
    <description>
      Three Body Targets with only missed shots, shown as tree bullet holes
      behind
    </description>
    <g transform="translate(-529 -221.754)">
      <g transform="translate(556.579 257.699)">
        <ellipse
          className={styles.a}
          cx="19.155"
          cy="20.523"
          rx="19.155"
          ry="20.523"
          transform="translate(65.162 44.659)"
        />
        <ellipse
          className={styles.a}
          cx="19.155"
          cy="20.523"
          rx="19.155"
          ry="20.523"
          transform="translate(3.452 64.673)"
        />
        <ellipse
          className={styles.a}
          cx="19.155"
          cy="20.523"
          rx="19.155"
          ry="20.523"
          transform="translate(128.54 64.673)"
        />
        <ellipse
          className={styles.a}
          cx="6.841"
          cy="6.841"
          rx="6.841"
          ry="6.841"
          transform="translate(77.476 12.291)"
        />
        <ellipse
          className={styles.a}
          cx="6.841"
          cy="6.841"
          rx="6.841"
          ry="6.841"
          transform="translate(14.098 43.98)"
        />
        <ellipse
          className={styles.a}
          cx="6.841"
          cy="6.841"
          rx="6.841"
          ry="6.841"
          transform="translate(140.9 43.98)"
        />
        <ellipse
          className={styles.b}
          cx="7.109"
          cy="7.109"
          rx="7.109"
          ry="7.109"
          transform="translate(34.391 24.198)"
        />
        <ellipse
          className={styles.c}
          cx="7.109"
          cy="7.109"
          rx="7.109"
          ry="7.109"
          transform="translate(34.391 48.89)"
        />
        <ellipse
          className={styles.d}
          cx="7.109"
          cy="7.109"
          rx="7.109"
          ry="7.109"
          transform="translate(120.012 24.198)"
        />
        <ellipse
          className={styles.e}
          cx="7.109"
          cy="7.109"
          rx="7.109"
          ry="7.109"
          transform="translate(120.012 48.89)"
        />
        <g transform="translate(0 0)">
          <path
            className={styles.f}
            d="M1545.024,564.559a3.672,3.672,0,0,0-1.179-1.764,9.5,9.5,0,0,0-3.439-1.639,34.369,34.369,0,0,0-5.485-.724,9.977,9.977,0,0,1-2.814-.566,2.54,2.54,0,0,1-1.72-2.217,7.423,7.423,0,0,1,.65-3.739,30.65,30.65,0,0,0,2.568-8.833,12.634,12.634,0,0,0-.254-4.723,6.973,6.973,0,0,0-4.074-4.8,12.165,12.165,0,0,0-4.351-.95,15.5,15.5,0,0,0-5.648.6,7.093,7.093,0,0,0-4.943,5.022,12.512,12.512,0,0,0-.3,4.806,26.139,26.139,0,0,0,1.636,6.551c.382,1,.828,1.98,1.178,2.992a7.677,7.677,0,0,1,.47,2.83,2.511,2.511,0,0,1-1.534,2.4,4.8,4.8,0,0,1-1.252.386c-1.478.2-2.964.341-4.446.509a12.823,12.823,0,0,0-4.538,1.228,4.409,4.409,0,0,0-2.4,2.308,13.392,13.392,0,0,0-.451,1.469,24.993,24.993,0,0,0-.533,5.9c.022,2.369.153,4.737.261,7.1.045.988.137,1.972.233,2.956q.226,2.312.489,4.617c.161,1.418.331,2.836.523,4.249q.332,2.469.71,4.927c.314,2.026.656,4.05.974,6.076.041.259.139.322.393.322q9.14-.013,18.276-.007h9.726q4.3,0,8.6,0c.194,0,.29-.026.326-.257.24-1.529.512-3.052.751-4.581q.391-2.5.742-5.008c.214-1.543.406-3.09.591-4.634.189-1.584.372-3.168.53-4.754.124-1.234.221-2.47.3-3.708.1-1.526.213-3.054.254-4.581a47.763,47.763,0,0,0-.156-6.438A14.4,14.4,0,0,0,1545.024,564.559Zm-23.638-19.809a8.017,8.017,0,0,1,.89-.063l0,.038c.516-.026,1.032-.079,1.548-.072.8.009,1.593.045,2.387.094a1.131,1.131,0,0,1,.538.207c.336.238.164.573.046.823-.324.688-.686,1.356-1.056,2.02-.429.766-.876,1.524-1.334,2.273a1.055,1.055,0,0,1-.422.387.458.458,0,0,1-.425-.053,4.351,4.351,0,0,1-.628-.807c-.531-.9-1.054-1.809-1.553-2.728a4.277,4.277,0,0,1-.592-1.332C1520.7,544.967,1520.957,544.827,1521.386,544.75Zm10.908,35.512c-.093.9-.172,1.811-.345,2.7a2.016,2.016,0,0,1-1.434,1.572,8.564,8.564,0,0,1-2.968.374c-.389.026-.778.072-1.168.075-1.265.009-2.532,0-3.8.005-.276,0-.552,0-.826,0-.838-.017-1.677-.034-2.515-.058a1.85,1.85,0,0,1-.3-.051l-1.752-.341a2.289,2.289,0,0,1-1.546-1.951c-.026-.425-.122-.845-.159-1.269s-.045-.845-.06-1.267c-.021-.586-.036-1.173-.056-1.759-.016-.473-.053-.948-.05-1.421.005-.941.043-1.882.048-2.824,0-.516-.057-1.032-.046-1.548.014-.724.069-1.447.1-2.172.01-.247-.017-.5.009-.742a21.734,21.734,0,0,1,.291-2.313,2.156,2.156,0,0,1,1.317-1.646,6.094,6.094,0,0,1,2.135-.423c1.167-.051,2.335-.086,3.5-.113.659-.017,1.317,0,1.975,0,.809,0,1.617-.029,2.424.009a24.245,24.245,0,0,1,2.889.242,2.3,2.3,0,0,1,1.6.9,3.263,3.263,0,0,1,.576,1.577c.057.71.125,1.42.165,2.129q.054.941.056,1.884.011,2.7,0,5.4c0,.629-.038,1.257-.052,1.884C1532.294,579.487,1532.331,579.878,1532.294,580.262Z"
            transform="translate(-1502.163 -495.875)"
          />
          <path
            className={styles.f}
            d="M1618.983,564.56a3.673,3.673,0,0,0-1.179-1.768,9.493,9.493,0,0,0-3.439-1.637,34.531,34.531,0,0,0-5.483-.725,9.925,9.925,0,0,1-2.815-.564,2.542,2.542,0,0,1-1.72-2.219,7.415,7.415,0,0,1,.65-3.738,30.618,30.618,0,0,0,2.568-8.833,12.627,12.627,0,0,0-.254-4.723,6.964,6.964,0,0,0-4.074-4.8,12.131,12.131,0,0,0-4.35-.95,15.436,15.436,0,0,0-5.649.6,7.089,7.089,0,0,0-4.943,5.022,12.544,12.544,0,0,0-.3,4.806,26.122,26.122,0,0,0,1.636,6.551c.382,1,.828,1.98,1.179,2.992a7.7,7.7,0,0,1,.468,2.829,2.5,2.5,0,0,1-1.534,2.4,4.741,4.741,0,0,1-1.252.387c-1.478.194-2.963.339-4.446.508a12.838,12.838,0,0,0-4.538,1.229,4.411,4.411,0,0,0-2.4,2.308,12.927,12.927,0,0,0-.449,1.469,24.882,24.882,0,0,0-.535,5.9c.022,2.369.153,4.739.261,7.1.045.988.137,1.973.233,2.958q.227,2.309.489,4.617c.161,1.418.333,2.834.523,4.249q.332,2.466.71,4.927c.314,2.027.658,4.05.975,6.075.039.261.137.324.393.322q9.138-.01,18.275-.005h9.726q4.3,0,8.6,0c.194,0,.29-.026.328-.259.238-1.528.511-3.052.749-4.581q.393-2.5.742-5.008c.214-1.541.406-3.088.592-4.634.188-1.582.372-3.167.53-4.753.123-1.234.221-2.472.3-3.708.1-1.528.213-3.055.254-4.583a48.008,48.008,0,0,0-.154-6.436A14.424,14.424,0,0,0,1618.983,564.56Zm-23.638-19.811a8.1,8.1,0,0,1,.89-.063l0,.038c.516-.026,1.032-.079,1.548-.074.8.009,1.593.046,2.387.1a1.1,1.1,0,0,1,.538.208c.336.238.165.571.046.823-.324.686-.686,1.356-1.056,2.02-.429.766-.876,1.522-1.334,2.272a1.059,1.059,0,0,1-.422.389.463.463,0,0,1-.425-.053,4.28,4.28,0,0,1-.626-.809c-.533-.9-1.056-1.807-1.553-2.728a4.171,4.171,0,0,1-.592-1.332C1594.654,544.965,1594.916,544.826,1595.345,544.749Zm10.966,32.464c0,.629-.038,1.257-.049,1.884-.009.389.029.78-.009,1.164-.093.9-.172,1.81-.345,2.7a2.016,2.016,0,0,1-1.433,1.572,8.528,8.528,0,0,1-2.968.372c-.389.027-.778.074-1.168.077-1.265.009-2.531,0-3.8,0-.274,0-.55.005-.826,0q-1.258-.026-2.516-.058a2.06,2.06,0,0,1-.3-.052q-.874-.172-1.752-.341a2.292,2.292,0,0,1-1.547-1.953c-.026-.423-.122-.844-.159-1.267s-.045-.845-.06-1.269c-.021-.586-.036-1.171-.055-1.757-.017-.475-.053-.948-.052-1.423.007-.941.043-1.881.048-2.822,0-.518-.055-1.034-.046-1.55.014-.724.067-1.447.1-2.171.01-.249-.017-.5.009-.742a22.173,22.173,0,0,1,.291-2.315,2.154,2.154,0,0,1,1.317-1.644,6.149,6.149,0,0,1,2.135-.425q1.751-.075,3.5-.113c.659-.015,1.317,0,1.975,0,.809,0,1.618-.029,2.424.007a24.255,24.255,0,0,1,2.891.242,2.3,2.3,0,0,1,1.594.9,3.27,3.27,0,0,1,.576,1.579c.057.71.125,1.418.167,2.129q.051.941.055,1.884Q1606.324,574.517,1606.311,577.213Z"
            transform="translate(-1449.319 -495.876)"
          />
          <path
            className={styles.f}
            d="M1598.876,559.373a5.8,5.8,0,0,0-1.864-2.788,14.989,14.989,0,0,0-5.433-2.589,54.381,54.381,0,0,0-8.663-1.144,15.744,15.744,0,0,1-4.446-.893,4.016,4.016,0,0,1-2.718-3.5,11.71,11.71,0,0,1,1.029-5.906,48.462,48.462,0,0,0,4.057-13.954,19.952,19.952,0,0,0-.4-7.461,11.018,11.018,0,0,0-6.438-7.58,19.2,19.2,0,0,0-6.873-1.5,24.47,24.47,0,0,0-8.922.955,11.2,11.2,0,0,0-7.81,7.931,19.817,19.817,0,0,0-.468,7.592,41.241,41.241,0,0,0,2.584,10.35c.6,1.584,1.308,3.129,1.862,4.727a12.154,12.154,0,0,1,.741,4.471,3.964,3.964,0,0,1-2.424,3.8,7.684,7.684,0,0,1-1.979.609c-2.333.309-4.681.538-7.021.8a20.24,20.24,0,0,0-7.172,1.941c-1.619.84-3.134,1.812-3.8,3.647a20.286,20.286,0,0,0-.712,2.32,39.5,39.5,0,0,0-.845,9.317c.036,3.743.242,7.485.413,11.225.07,1.56.216,3.117.369,4.67q.357,3.652.771,7.3c.255,2.241.525,4.478.825,6.712q.527,3.9,1.123,7.784c.5,3.2,1.039,6.4,1.539,9.6.063.411.218.511.621.509q14.435-.018,28.872-.008h15.365q6.8,0,13.594.005c.307,0,.459-.041.518-.408.377-2.414.807-4.821,1.186-7.237q.618-3.95,1.171-7.912c.338-2.436.641-4.879.934-7.321.3-2.5.587-5,.837-7.51.2-1.951.35-3.906.48-5.86.16-2.411.336-4.825.4-7.239a75.707,75.707,0,0,0-.245-10.169A22.883,22.883,0,0,0,1598.876,559.373Zm-37.344-31.295a12.788,12.788,0,0,1,1.406-.1l0,.062c.816-.043,1.632-.125,2.447-.115,1.258.012,2.517.07,3.772.151a1.77,1.77,0,0,1,.85.326c.532.377.259.905.072,1.3-.511,1.085-1.082,2.143-1.668,3.191-.677,1.211-1.384,2.407-2.107,3.59a1.667,1.667,0,0,1-.667.614.73.73,0,0,1-.672-.084,6.808,6.808,0,0,1-.989-1.277c-.842-1.423-1.667-2.856-2.453-4.31a6.709,6.709,0,0,1-.934-2.1C1560.44,528.42,1560.855,528.2,1561.532,528.079Zm17.232,56.1c-.146,1.426-.269,2.861-.544,4.266a3.188,3.188,0,0,1-2.265,2.483,13.481,13.481,0,0,1-4.687.59c-.615.041-1.231.115-1.846.118-2,.015-4,.007-6,.009-.436,0-.871.007-1.307,0-1.324-.027-2.649-.055-3.973-.091a3.09,3.09,0,0,1-.477-.082q-1.384-.27-2.769-.54a3.619,3.619,0,0,1-2.443-3.083c-.041-.67-.192-1.334-.252-2s-.07-1.334-.094-2c-.033-.926-.056-1.852-.087-2.777-.026-.748-.084-1.5-.081-2.246.01-1.486.067-2.973.076-4.461,0-.814-.088-1.63-.072-2.445.022-1.145.106-2.287.156-3.432.015-.391-.028-.785.015-1.173a33.751,33.751,0,0,1,.461-3.655,3.4,3.4,0,0,1,2.078-2.6,9.707,9.707,0,0,1,3.373-.671c1.845-.079,3.69-.134,5.532-.178,1.041-.026,2.081,0,3.122,0,1.277,0,2.555-.046,3.83.012a38.983,38.983,0,0,1,4.564.382,3.626,3.626,0,0,1,2.52,1.416,5.136,5.136,0,0,1,.911,2.493c.091,1.121.2,2.241.261,3.364q.085,1.489.089,2.978.018,4.261,0,8.523c0,.993-.06,1.985-.08,2.976C1578.765,582.956,1578.827,583.575,1578.765,584.18Z"
            transform="translate(-1481.443 -512.002)"
          />
        </g>
        <ellipse
          className={styles.d}
          cx="7.109"
          cy="7.109"
          rx="7.109"
          ry="7.109"
          transform="translate(34.391 76.751)"
        />
        <ellipse
          className={styles.c}
          cx="7.109"
          cy="7.109"
          rx="7.109"
          ry="7.109"
          transform="translate(120.012 75.254)"
        />
      </g>
      <g transform="translate(529 274.033)">
        <path
          className={styles.g}
          d="M1524,475s1,15,5,4c0,0-1,10,6,3,0,0-11,10,1,9,0,0-7,1-1,12,0,0-5-10-8-8s-3,4-3,6c0,0,0-14-10-8,0,0,13-5-2-11C1512,482,1522,487,1524,475Z"
          transform="translate(-1512 -475)"
        />
        <rect
          width="8.129"
          height="8.129"
          rx="3.484"
          transform="translate(9.032 9.935)"
        />
      </g>
      <g transform="matrix(0.485, 0.875, -0.875, 0.485, 756.248, 284.75)">
        <path
          className={styles.g}
          d="M12,0s1,15,5,4c0,0-1,10,6,3,0,0-11,10,1,9,0,0-7,1-1,12,0,0-5-10-8-8s-3,4-3,6c0,0,0-14-10-8,0,0,13-5-2-11C0,7,10,12,12,0Z"
        />
        <rect
          width="8.129"
          height="8.129"
          rx="3.484"
          transform="translate(9.032 9.935)"
        />
      </g>
      <g transform="matrix(0.485, 0.875, -0.875, 0.485, 690.918, 221.754)">
        <path
          className={styles.g}
          d="M12,0s1,15,5,4c0,0-1,10,6,3,0,0-11,10,1,9,0,0-7,1-1,12,0,0-5-10-8-8s-3,4-3,6c0,0,0-14-10-8,0,0,13-5-2-11C0,7,10,12,12,0Z"
        />
        <rect
          width="8.129"
          height="8.129"
          rx="3.484"
          transform="translate(9.032 9.935)"
        />
      </g>
    </g>
  </svg>
);

MissedTargetIcon.displayName = 'MissedTargetIcon';

MissedTargetIcon.defaultProps = {
  className: ''
};

export default MissedTargetIcon;
